import { useNavigate } from "react-router-dom";
// import LoginSection from "./login";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../styles/carousel.css"
import { Footer } from "./Footer";
import { LoginBox } from "./Login";

const helpers = [
  {
    label: "Homeowners",
    desc: "Set your own price, save money, create local jobs",
    src: "https://cdn.builder.io/api/v1/image/assets/TEMP/d8747d81081a0758a2ed60e992e8ee50bd08f96b250b2bfa1b927b0649288509?placeholderIfAbsent=true&apiKey=7f2e90e22cd648eabadd6329c5e7c0cc",
  },
  {
    label: "Helpers",
    desc: "Earn extra income by helping your neighbours.",
    src: "https://cdn.builder.io/api/v1/image/assets/TEMP/955aa4f8e874986bd2e97bfb17833400a5fca8b86486c44c9f4b0d47a61af018?placeholderIfAbsent=true&apiKey=7f2e90e22cd648eabadd6329c5e7c0cc",
  },
  {
    label: "Community Impact",
    desc: "Create a stronger and more connected neighbourhood",
    src: "https://cdn.builder.io/api/v1/image/assets/TEMP/191093febd65a18de24bc7f15208f607cfa0bd970320601fdf8578dc6790d70f?placeholderIfAbsent=true&apiKey=7f2e90e22cd648eabadd6329c5e7c0cc",
  },
];

const carousels = {
  homeowners: [
    {
      src: "https://i.imgur.com/WDIzeaE.png"
    },
    {
      src: "https://i.imgur.com/ovwOfhX.png"
    },
    {
      src: "https://i.imgur.com/jjusi5E.png"
    },
    {
      src: "https://i.imgur.com/epTpUFs.png"
    },
    {
      src: "https://i.imgur.com/uMkU3MO.png"
    },
    {
      src: "https://i.imgur.com/GZcx3Y2.png"
    }
  ],
  helpers: [
    {
      src: "https://i.imgur.com/310OEBh.png"
    },
    {
      src: "https://i.imgur.com/ioYWZ0Q.png"
    },
    {
      src: "https://i.imgur.com/x6Xq9L4.png"
    },
    {
      src: "https://i.imgur.com/9JIOjxG.png"
    },
    {
      src: "https://i.imgur.com/YBo9ozH.png"
    },
    {
      src: "https://i.imgur.com/xwqm8AH.png"
    }
  ]
}


export function OnboardingPage() {
  const navigate = useNavigate();
  
  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5500,
    pauseOnHover: false,
    waitForAnimate: true,
  };

  return (
    <div className="min-h-screen">

      {/* Logo */}
      <div className="flex flex-col justify-center items-center">
        <div className="relative">
          <img
            loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/695e635bfc216577bbec9a4cd98ee5a3b037dce0ea72f0d6aeaacf06d26ad442?placeholderIfAbsent=true&apiKey=7f2e90e22cd648eabadd6329c5e7c0cc"
            alt="Service illustration"
            className="object-contain w-[260px] md:w-[300px] lg:w-[340px] aspect-[2.31]"
          />
        </div>
      </div>

      {/* Main */}
      <div className="flex justify-center items-center bg-[#F6F6F6] py-8 md:py-16">
        <div className="container max-w-[400px] md:max-w-[720px] lg:max-w-7xl px-8 flex flex-col lg:flex-row justify-between gap-4 lg:gap-8">
          {/* Details */}
          <div className="">
            <h1 className="max-w-[480px] md:max-w-none mx-auto md:mx-0 md:text-6xl md:w-full lg:max-w-[600px] text-3xl font-bold">
              Like ride hailing or food delivery, but for<br/>snow and lawns
            </h1>
            <p className="mt-2 text-xl">Pay What You Want.<br className="md:hidden"/> Same Day Service.<br/> On-Demand. <br /> Seasonal Contract: $360 single car, $420 double car, $510 triple car driveway</p>
            <div className="flex">
              <div className="mt-4 flex flex-col w-[422px]">
                <p className="flex mb-2 text-lg font-bold">
                  Sign Up
                </p>
                <div className="flex flex-row flex-wrap xs:flex-nowrap gap-4">
                  {/* One */}
                  <div className="flex flex-col gap-3  w-full xs:w-auto">
                    <h3>Save money as a</h3>
                    <button
                      className="text-sm md:text-base bg-black text-white flex justify-center md:w-[185px] w-full px-5 md:px-10 py-2 rounded-full"
                      onClick={() => navigate("/homeowner/post")}
                    >
                      Homeowner
                    </button>
                  </div>
                  {/* Two */}
                  <div className="flex flex-col gap-3 w-full xs:w-auto">
                    <h3>Earn money as a</h3>
                    <button
                      className="text-sm md:text-base border-black border-2 flex justify-center md:w-[220px] w-full px-5 py-2 rounded-full"
                      onClick={() => navigate("/helper")}
                    >
                      Neighbourhood Helper
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <button
              onClick={() => navigate("/learnMore")}
              className="my-4 underline font-medium text-black"
            >
              Learn More
            </button>
          </div>
          {/* Form */}
          <LoginBox />
        </div>
      </div>

      {/* 3 Sections */}
      <div className="px-4 py-12 lg:pb-20 flex flex-col gap-4 justify-center items-center">
        <div className="max-w-[360px] md:max-w-none">
          <h2 className="text-center xs:px-4 max-w-3xl text-2xl md:mb-4 md:text-4xl font-bold">
          We are a social enterprise focused on neighbours helping neighbours.
          </h2>
          <h1 className="text-center pt-2 xs:pt-0 text-xl md:mb-4 md:text-xl font-medium">
          Your equipment. Neighbourhood helpers. Big savings.
          </h1>
        </div>
        <div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-12 md:gap-x-20 lg:grid-cols-3 justify-center items-center lg:gap-32">
          {helpers.map(({ label, desc, src }, i) => (
            <div
              key={i}
              className={`flex flex-col justify-center items-center max-w-60 ${
                i === 2 ? "md:col-span-2 mx-auto lg:col-span-1 lg:mx-0" : ""
              }`}
            >
              <img src={src} alt={label} className={`md:h-28 ${i === 1 ? "relative -left-4" : ""}`} />
              <h2 className="text-center  md:text-xl font-semibold">{label}</h2>
              <p className="text-center md:text-base xl:text-lg">{desc}</p>
            </div>
          ))}
        </div>
        <h2 className="mt-12 text-center text-xl md:mb-4 xs:text-2xl md:text-3xl font-medium">
          How it works: Screenshots
        </h2>
        <div className="grid px-4 grid-cols-1 gap-12 md:flex md:w-full md:justify-between md:gap-12 max-w-4xl">
          <div className="max-w-72 lg:max-w-80">
            <h4 className="text-center my-2 font-medium text-lg sm:text-xl">Homeowners</h4>
            <Slider {...carouselSettings} className="border-2 border-black">
              {carousels.homeowners.map(({ src }, i) => (
                <div key={i} className="px-2 w-16">
                  <img src={src} alt="Homeowner" className="w-full h-full object-cover" />
                </div>
              ))}
            </Slider>
          </div>
          <div className="max-w-72 lg:max-w-80">
            <h4 className="text-center my-2 font-medium text-lg sm:text-xl">Helpers</h4>
            <Slider {...carouselSettings} className="border-2 border-black">
              {carousels.helpers.map(({ src }, i) => (
                <div key={i} className="px-2 w-16">
                  <img src={src} alt="Helper" className="w-full h-full object-cover" />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
